import { render, staticRenderFns } from "./languageSelector.vue?vue&type=template&id=de665e8c"
import script from "./languageSelector.vue?vue&type=script&lang=js"
export * from "./languageSelector.vue?vue&type=script&lang=js"
import style0 from "./languageSelector.vue?vue&type=style&index=0&id=de665e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports